/* eslint-disable no-underscore-dangle */
/* eslint-disable camelcase */
import {
  STATION_1,
  STATION_2,
  STATION_3,
  STATION_4,
  WARM_UP,
} from './constants/stations';

const findById = (items, id) => items.find((item) => item._id === id);

export const transformIncomingLocationStationsToLocal = (
  incomingLocationStations,
  videos
) => {
  return incomingLocationStations.map((incomingLocationStation) => {
    const {
      station_0,
      station_1,
      station_2,
      station_3,
      station_4,
    } = incomingLocationStation;
    if (videos) {
      return {
        [WARM_UP]: findById(videos, station_0._id),
        [STATION_1]: {
          A: findById(videos, station_1.video_1._id),
          B: findById(videos, station_1.video_2._id),
          C: findById(videos, station_1.video_3._id),
        },
        [STATION_2]: {
          A: findById(videos, station_2.video_1._id),
          B: findById(videos, station_2.video_2._id),
          C: findById(videos, station_2.video_3._id),
        },
        [STATION_3]: {
          A: findById(videos, station_3.video_1._id),
          B: findById(videos, station_3.video_2._id),
          C: findById(videos, station_3.video_3._id),
        },
        [STATION_4]: {
          A: findById(videos, station_4.video_1._id),
          B: findById(videos, station_4.video_2._id),
          C: findById(videos, station_4.video_3._id),
        },
      };
    }
    return {
      [WARM_UP]: station_0,
      [STATION_1]: {
        A: station_1.video_1,
        B: station_1.video_2,
        C: station_1.video_3,
      },
      [STATION_2]: {
        A: station_2.video_1,
        B: station_2.video_2,
        C: station_2.video_3,
      },
      [STATION_3]: {
        A: station_3.video_1,
        B: station_3.video_2,
        C: station_3.video_3,
      },
      [STATION_4]: {
        A: station_4.video_1,
        B: station_4.video_2,
        C: station_4.video_3,
      },
    };
  });
};

export const getVideosIdsFromIncomingLocationStations = (
  incomingLocationStations
) => {
  const videosIds = [];
  incomingLocationStations.forEach((incomingLocationStation) => {
    const {
      station_0,
      station_1,
      station_2,
      station_3,
      station_4,
    } = incomingLocationStation;

    videosIds.push(
      station_0._id,
      station_1.video_1._id,
      station_1.video_2._id,
      station_1.video_3._id,
      station_2.video_1._id,
      station_2.video_2._id,
      station_2.video_3._id,
      station_3.video_1._id,
      station_3.video_2._id,
      station_3.video_3._id,
      station_4.video_1._id,
      station_4.video_2._id,
      station_4.video_3._id
    );
  });

  return [...new Set(videosIds)];
};
